import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ShoppingBag } from 'lucide-react';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { getApiOauthProviderAuthorize } from '@/api/generated/oauth/oauth';
import { useAuthStore } from '@/stores/useAuthStore';
import { toast } from 'sonner';

interface NuvemshopLoginButtonProps {
  label?: string;
}

export const NuvemshopLoginButton: React.FC<NuvemshopLoginButtonProps> = ({ 
  label = 'Continuar com Nuvemshop' 
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      // Ensure no residual token is sent to the authorize endpoint
      if (!useAuthStore.getState().isAuthenticated) {
        useAuthStore.getState().logout();
      }

      const res = (await getApiOauthProviderAuthorize('nuvemshop')) as unknown as { authorizationUrl?: string; url?: string };
      
      const authUrl = res?.authorizationUrl || res?.url;
      if (authUrl) {
        window.location.href = authUrl;
      } else {
        toast.error('Não foi possível obter a URL de autorização do servidor.');
        setIsLoading(false);
      }
    } catch (err: any) {
      const msg = err.response?.data?.message || err.message || 'Falha ao iniciar login com Nuvemshop';
      toast.error(msg);
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="w-full gap-2 border-blue-200 hover:bg-blue-50/50 dark:border-blue-900/50 dark:hover:bg-blue-900/20 text-blue-700 dark:text-blue-300 transition-colors shadow-sm"
      onClick={handleLogin}
      disabled={isLoading}
    >
      {isLoading ? (
        <LoadingSpinner size="sm" className="text-blue-600" />
      ) : (
        <ShoppingBag className="h-4 w-4" />
      )}
      <span className="font-medium">{label}</span>
    </Button>
  );
};
